<template>
  <div>
    <v-container class="pt-0 pb-5">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <v-btn color="primary-dark" @click="$router.go(-1)" density="compact" variant="outlined">
              <v-icon left>mdi-arrow-left</v-icon>
              Retour
            </v-btn>
            <div class="text-h6 mt-3 mb-4" v-if="inscription.prenom && inscription.nom">Modifier les informations de {{
              inscription.prenom }} {{ inscription.nom }}</div>


            <div class="text-h6"><v-icon icon="mdi-pencil" color="primary"></v-icon>Informations modifiables</div>
            <v-form ref="formEditCoureur" v-model="valid" class="mb-5 mt-4"
              v-if="inscription.coureur && inscription.coureur.champs">
              <v-row>
                <v-col :md="champ.type == 'html' ? 12 : 6" cols="12" class="py-0"
                  v-for="(champ, index_champ) in editable_fields" :key="index_champ">
                  <div v-if="is_editable(champ)">
                    <div v-if="champ.nom == 'ville'">
                      <Champ_Select_Ville v-if="is_commune_francaise" :champ="champ"
                        :cp="inscription.coureur.champs.cp.value" :inscription="inscription"></Champ_Select_Ville>
                      <Champ_Text v-else :champ="champ" :inscription="inscription"></Champ_Text>
                    </div>
                    <div v-else-if="champ.nom == 'licence'">
                      <Champ_Licence :champ="champ" :inscription="inscription"></Champ_Licence>
                    </div>
                    <div v-else-if="champ.nom == 'numero_pps'">
                      <Champ_PPS :champ="champ" :inscription="inscription"></Champ_PPS>
                    </div>
                    <div v-else-if="champ.nom == 'numero_licence_ffr'">
                      <Champ_Licence_FFR :champ="champ" :inscription="inscription"></Champ_Licence_FFR>

                    </div>
                    <div v-else-if="champ.nom == 'questionnaire_sante_ffr'">
                      <Champ_Questionnaire_Sante_FFR :champ="champ" :inscription="inscription" :is_mineur="is_mineur">
                      </Champ_Questionnaire_Sante_FFR>
                    </div>
                    <div v-else-if="champ.nom == 'date_naissance'">
                      <Champ_Date_Naissance :champ="champ" :inscription="inscription" disable_year="1">
                      </Champ_Date_Naissance>
                    </div>
                    <div v-else>
                      <Champ_HTML v-if="champ.type == 'html'" :champ="champ" :inscription="inscription"></Champ_HTML>
                      <Champ_Text v-if="champ.type == 'text' || champ.type == 'tel'" :champ="champ"
                        :inscription="inscription"></Champ_Text>
                      <Champ_Select v-if="champ.type == 'select'" :champ="champ" :inscription="inscription">
                      </Champ_Select>
                      <Champ_Date v-if="champ.type == 'date'" :champ="champ" :inscription="inscription"></Champ_Date>

                      <Champ_Number v-if="champ.type == 'number'" :champ="champ" :inscription="inscription">
                      </Champ_Number>
                      <Champ_Boolean v-if="champ.type == 'boolean'" :champ="champ" :inscription="inscription">
                      </Champ_Boolean>
                      <Champ_Document v-if="champ.type == 'document'" :champ="champ" :inscription="inscription">
                      </Champ_Document>
                    </div>
                  </div>
                </v-col>
              </v-row>
              <v-row class="d-flex justify-center">
                <v-col md="4" cols="12">
                  <v-btn color="primary-dark" block class="sm-fullwidth mt-2 inscription_btn" variant="tonal"
                    @click="validate"> <v-icon icon="mdi-arrow-right-bold"></v-icon> Enregistrer les modifications
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
            <v-alert color="dark-red" variant="tonal" class="mb-2" v-for="(error, index_error) in errors"
              :key="index_error" type="error">
              {{ error }}
            </v-alert>
            <div class="text-h6 mt-3 mb-4"><v-icon icon="mdi-pencil-off" color="primary"></v-icon> Informations non
              modifiables</div>
            <div class="text-body-1 bordered rounded pa-1 bg-grey_1 my-3"><v-icon icon="mdi-gesture-tap"></v-icon> Les
              informations d'identité suivantes ne sont pas modifiable. En cas de problème, merci de contact
              l'organisateur.</div>
            <v-row class="mt-2" v-if="not_editable_field">
              <v-col md="6" cols="12" class="py-0" v-for="(champ, index_champ) in not_editable_field"
                :key="index_champ">
                <label class="field_label">{{ champ[0] }}</label>
                <v-text-field v-model="champ[1]" disabled></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="display_confirm_dialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-h6">Modification des informations</div>
          <p>Vos informations ont bien été modifiées.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary-dark" text @click="display_confirm_dialog = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Inscription from "@/classes/Fiche_Coureur/Inscription.class";
import List_Champs_Formulaire from "@/classes/Champs_Formulaire/List_Champs_Formulaire.class";
import Champ_Text from "@/components/Inscription/Champs_Formulaire/Champ_Text.vue";
import Champ_Date from "@/components/Inscription/Champs_Formulaire/Champ_Date.vue";
import Champ_Date_Naissance from "@/components/Inscription/Champs_Formulaire/Champ_Date_Naissance.vue";
import Champ_HTML from "@/components/Inscription/Champs_Formulaire/Champ_HTML.vue";
import Champ_Number from "@/components/Inscription/Champs_Formulaire/Champ_Number.vue";
import Champ_Select from "@/components/Inscription/Champs_Formulaire/Champ_Select.vue";
import Champ_Boolean from "@/components/Inscription/Champs_Formulaire/Champ_Boolean.vue";
import Champ_Document from "@/components/Inscription/Champs_Formulaire/Champ_Document.vue";
import Champ_Select_Ville from "@/components/Inscription/Champs_Formulaire/Champ_Select_Ville.vue";
import Champ_Licence from "@/components/Inscription/Champs_Formulaire/Champ_Licence.vue";
import Champ_PPS from "@/components/Inscription/Champs_Formulaire/Champ_PPS.vue";
import Champ_Licence_FFR from "@/components/Inscription/Champs_Formulaire/Champ_Licence_FFR.vue";
import Champ_Questionnaire_Sante_FFR from "@/components/Inscription/Champs_Formulaire/Champ_Questionnaire_Sante_FFR.vue";

export default {
  components: {
    Champ_Text,
    Champ_Date,
    Champ_Number,
    Champ_Select,
    Champ_Boolean,
    Champ_Document,
    Champ_Select_Ville,
    Champ_Licence,
    Champ_HTML,
    Champ_PPS,
    Champ_Licence_FFR,
    Champ_Questionnaire_Sante_FFR,
    Champ_Date_Naissance,

  },
  data() {
    return {
      errors: [],
      inscription: {},
      list_champs_formulaires: {},
      valid: false,
      display_confirm_dialog: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    editable_fields() {
      let editable = [];
      if (!this.inscription.coureur || !this.inscription.coureur.champs) {
        return editable;
      }
      let champs_meet_conditions = this.inscription.coureur.get_list_champs_meet_conditions()
      if(!champs_meet_conditions){
        return editable;
      }
      for (const champ of Object.entries(champs_meet_conditions)) {
        if (this.is_editable(champ[1])) {
          editable.push(champ[1]);
        }
      }
      return editable;
    },

    is_commune_francaise() {
      return this.inscription.coureur.champs.pays && this.inscription.coureur.champs.pays.value == "FRA" && this.inscription.coureur.champs.cp && this.inscription.coureur.champs.cp.value.length == 5;
    },
    not_editable_field() {
      let editable = [
        ["nom", this.inscription.nom],
        ["prenom", this.inscription.prenom],
        ["sexe", this.inscription.sexe],
      ];
      if (!this.inscription.champs) {
        return editable;
      }

      for (const champ of Object.entries(this.inscription.champs)) {
        if (!this.is_inscription_champ_editable(champ[0]) && champ[0] != "type_document" && champ[0] != "cm_document" && champ[0] != "licence_document" && champ[0] != "autre_licence_document" && champ[0] != "pps_document") {
          editable.push(champ);
        }
      }
      return editable;
    },
  },

  methods: {
    /* Vérifie si un champ rempli les condition d'affichage dans le formulaire */
    condition_meet(champ) {
      if (champ.nom == "certificat_medical_ffr" && this.is_mineur()) {
        return false;
      }
      if (!champ.condition_nom || champ.condition_nom === "") {
        return true;
      }
      for (const list_champs of Object.entries(this.inscription.coureur.champs)) {

        let champ_condition = list_champs[1];

        if (champ_condition.nom == champ.condition_nom) {
          if (champ.condition_met(champ_condition.value) === false) {
            this.on_condition_not_meet(champ);
          }
          return champ.condition_met(champ_condition.value);
        }
      }
      return true;
    },

    is_mineur() {
      if (!this.inscription.coureur.champs.date_naissance) {
        return false;
      }
      let date_naissance = this.$moment(this.inscription.coureur.champs.date_naissance.value);
      let date_today = this.$moment();
      let age = date_today.diff(date_naissance, "years");
      return age < 18;

    },
    /* Si la condition d'affichage n'est pas rempli, on vide le champ */
    on_condition_not_meet(champ) {
      for (const champ_to_erase of Object.entries(this.inscription.coureur.champs)) {
        if (champ_to_erase[1].nom == champ.nom) {
          champ_to_erase[1].value = "";
        }
      }
    },

    async validate() {
      this.errors = [];
      let res = await this.$refs.formEditCoureur.validate();
      if (res.valid) {
        await this.handle_update_informations();
      } else {
        this.errors.push("Certains champs nécessitent votre attention, merci de les vérifier avant de continuer.");
      }
    },

    get_cp() {
      for (let i = 0; i < this.inscription.coureur.champs.length; i++) {
        if (this.inscription.coureur.champs[i].nom == "cp") {
          return this.inscription.coureur.champs[i].value;
        }
      }
      return -1;
    },

    is_inscription_champ_editable(champ) {
      let not_editable_fields = ["nom", "prenom", "sexe", "type_document", "licence_document", "autre_licence_document", "cm_document", "pps_document", "sas_preferentiel_10km"];
      if (not_editable_fields.includes(champ)) {
        return false;
      }
      return true;
    },

    is_editable(champ) {
      let not_editable_fields = ["nom", "prenom", "sexe", "type_document", "licence_document", "autre_licence_document", "cm_document", "pps_document", "sas_preferentiel_10km", "numero_licence_ffr","type_inscription_ffr"];
      if (not_editable_fields.includes(champ.nom)) {
        return false;
      }
      return true;
    },
    async handle_update_informations() {
      let is_auth = this.mainStore.authUser.isLogged;
      let is_token_provided = this.$route.query.token && this.$route.query.token != "";
      if (is_token_provided) {
        let update_coureur = await this.inscription.update_informations_by_token(this.$route.query.token);
        if (update_coureur.error) {
          this.errors.push("Une erreur est survenue lors de la modification de vos informations. Merci de réessayer ultérieurement.(Erreur : " + update_coureur.error + ")");
        } else {
          this.display_confirm_dialog = true;
        }
        return;
      }
      if (is_auth) {
        let update_coureur = await this.inscription.update_informations();
        if (update_coureur.error) {
          this.errors.push("Une erreur est survenue lors de la modification de vos informations. Merci de réessayer ultérieurement.(Erreur : " + update_coureur.error + ")");
        } else {
          this.display_confirm_dialog = true;
        }
        return;
      }
    },

    /* Vérifie le mode d'authentification (par compte connecté ou token d'authentification) */
    async handle_access_initialization() {
      let is_auth = this.mainStore.authUser.isLogged;
      let is_token_provided = this.$route.query.token && this.$route.query.token != "";
      if (is_token_provided) {
        await this.token_initialization();
        return;
      }
      if (is_auth) {
        await this.auth_initialization();
        return;
      }
      this.$router.push({ name: "FicheCoureur" });
    },
    async auth_initialization() {
      this.inscription = new Inscription();
      this.inscription.id = this.$route.params.id_inscription;
      let request = await this.inscription.get();
      if (!request) {
        this.$router.push({ name: "FicheCoureur" });
      }
    },
    async token_initialization() {
      this.inscription = new Inscription();
      let request = await this.inscription.get_by_token(this.$route.query.token);
      if (!request) {
        this.$router.push({ name: "FicheCoureur" });
      }
    },
  },

  async created() {
    await this.handle_access_initialization();

    this.inscription.align_coureur_infos_with_inscription();
    this.inscription.populate_coureur_infos_with_inscription();
    this.list_champs_formulaires = new List_Champs_Formulaire();
    this.list_champs_formulaires.list_ids_parcours = [this.inscription.id_course];
    this.list_champs_formulaires.id_module = this.mainStore.module.id;
    await this.list_champs_formulaires.fetch();
    this.inscription.coureur.rebuild_list_champs(this.list_champs_formulaires.list);

  },
};
</script>

<style lang="scss">
.v-field--disabled {
  opacity: 0.8 !important;
}
</style>